/* eslint-disable no-new */
import './src/styles/global.scss'
import appWrapper from './app-wrapper'
import 'focus-visible'
// import UpdateViewportHeight from '~scripts/UpdateViewportHeight'

export const onInitialClientRender = () => {
  const wrapper = document.getElementById('gatsby-focus-wrapper');
  if (wrapper) wrapper.style = undefined;
}

export const wrapRootElement = appWrapper

// new UpdateViewportHeight()

document.addEventListener('DOMContentLoaded', function (event) {
  document.addEventListener('click', (e) => {
    if (e.target && e.target.closest('#recite-me-button')) {
      loadService()
      return false
    }
  })
})

var serviceUrl = '//api.reciteme.com/asset/js?key='
var serviceKey = '1ff5f6f3185a48a637695c45c660bad5e0a4c02f'
var options = {} // Options can be added as needed
var autoLoad = false
var enableFragment = '#reciteEnable'

var loaded = []; var frag = !1; window.location.hash === enableFragment && (frag = !0); function loadScript (c, b) { var a = document.createElement('script'); a.type = 'text/javascript'; a.readyState ? a.onreadystatechange = function () { if (a.readyState == 'loaded' || a.readyState == 'complete')a.onreadystatechange = null, void 0 != b && b() } : void 0 != b && (a.onload = function () { b() }); a.src = c; document.getElementsByTagName('head')[0].appendChild(a) } function _rc (c) { c += '='; for (var b = document.cookie.split(';'), a = 0; a < b.length; a++) { for (var d = b[a]; d.charAt(0) == ' ';)d = d.substring(1, d.length); if (d.indexOf(c) == 0) return d.substring(c.length, d.length) } return null } function loadService (c) { for (var b = serviceUrl + serviceKey, a = 0; a < loaded.length; a++) if (loaded[a] == b) return; loaded.push(b); loadScript(serviceUrl + serviceKey, function () { typeof _reciteLoaded === 'function' && _reciteLoaded(); typeof c === 'function' && c(); Recite.load(options); Recite.Event.subscribe('Recite:load', function () { Recite.enable() }) }) }_rc('Recite.Persist') == 'true' && loadService(); (autoLoad && _rc('Recite.Persist') != 'false' || frag) && loadService()
